import React from 'react';
import { hasIn } from 'lodash';
import marketingAndAnalyticsService from '../../services/marketingAndAnalytics/marketingAndAnalyticsService.js';

const InfoboxGroup = (props) => {
    const handleClick = async function (event) {
        // event.preventDefault();
        if (hasIn(event, 'target.tagName') && hasIn(event, 'target.href')) {
            if (event.target.tagName === 'A') {
                await marketingAndAnalyticsService.recordInfoboxClick({
                    linkUrl: event.target.href,
                });
            }
        }
        if (
            hasIn(event, 'target.parentElement.tagName') &&
            hasIn(event, 'target.parentElement.href')
        ) {
            if (event.target.parentElement.tagName === 'A') {
                await marketingAndAnalyticsService.recordInfoboxClick({
                    linkUrl: event.target.parentElement.href,
                });
            }
        }
    };
    return <>{React.cloneElement(props.children, { onClick: handleClick })}</>;
};

export default InfoboxGroup;
